import HeaderSearch from './HeaderSearch';

export default HeaderSearch;
